import { render } from "./AuthMasterView.vue?vue&type=template&id=ccdb3e94"
import script from "./AuthMasterView.vue?vue&type=script&lang=js"
export * from "./AuthMasterView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__